module.exports = __webpack_public_path__ + "img/carlo_pistone.7bcb8765.png";